import React, { JSX } from 'react';
import SearchFilter from './SearchFilter';
import {
  AddFilterType,
  FilterPanelType,
  LocationFilterOptionsType,
  LocationFiltersType,
  OnQueryInputChangeType,
  ProviderFilterOptionsType,
  ProviderFiltersType,
  RemoveFilterType,
  ReplaceLocationFiltersType,
  SetActiveFilterPanelType,
  SetControlPanelType,
  UpdateFilterType,
  UpdateQueryType,
} from 'components/types/FilterTypes';
import LocationFilter from './LocationFilter';
import {
  BuildAddress,
  SetLatLng,
} from 'components/types/LocationFunctionTypes';

type SearchBarProps = {
  clearAllFilters: Function;
  filterPanels: Array<FilterPanelType>;
  query?: string;
  setActiveFilterPanel: SetActiveFilterPanelType;
  filters: ProviderFilterOptionsType | LocationFilterOptionsType;
  queryInputValue: string;
  onQueryInputChange: OnQueryInputChangeType;
  updateQuery: UpdateQueryType;
  updateFilter: UpdateFilterType;
  removeFilter: RemoveFilterType;
  addFilter: AddFilterType;
  selectedFacets: any;
  selectedFilters: ProviderFiltersType | LocationFiltersType;
  replaceFilter: Function;
  activeFilterPanel?: string;
  buildAddress: BuildAddress;
  geolocate: () => void;
  geolocating: boolean;
  removeLocationFilters: () => void;
  replaceLocationFilters: ReplaceLocationFiltersType;
  setLatLng: SetLatLng;
  setControlPanel?: SetControlPanelType;
  searchType: string;
  count?: number;
  closeMobileControls: () => void;
  controlPanel?: string;
  resultsCount?: number;
};

const SearchBar = (props: SearchBarProps): JSX.Element => {
  const {
    filterPanels,
    setActiveFilterPanel,
    queryInputValue,
    onQueryInputChange,
    updateQuery,
    selectedFilters,
    replaceFilter,
    buildAddress,
    geolocate,
    geolocating,
    removeLocationFilters,
    replaceLocationFilters,
    setLatLng,
    searchType,
  } = props;

  const initialFilterPanels = filterPanels.filter(
    (filterPanel: FilterPanelType) =>
      filterPanel.id === 'search' ||
      filterPanel.id === 'location' ||
      filterPanel.id === 'preferredProvider'
  );

  return (
    <div className="search-bar-container">
      <div className="jss-inner-container">
        <div className="search-bar">
          {initialFilterPanels.map((filterPanel: FilterPanelType) => {
            return (
              <div
                className="filter-btn-container btn-mobile-fw"
                key={filterPanel.id}
              >
                {filterPanel.id === 'search' && (
                  <div className="search-bar-btn">
                    <SearchFilter
                      minimumCharacters={2}
                      onQueryInputChange={onQueryInputChange}
                      placeholder={
                        searchType === 'providers'
                          ? 'Specialty, clinical focus area or provider name'
                          : 'Location name or facility type'
                      }
                      queryInputValue={queryInputValue}
                      searchType={searchType}
                      updateQuery={updateQuery}
                    />
                  </div>
                )}

                {filterPanel.id === 'location' && (
                  <div className="search-bar-btn">
                    <LocationFilter
                      buildAddress={buildAddress}
                      geolocate={geolocate}
                      geolocating={geolocating}
                      removeLocationFilters={removeLocationFilters}
                      replaceLocationFilters={replaceLocationFilters}
                      selectedFilters={selectedFilters}
                      setActiveFilterPanel={setActiveFilterPanel}
                      setLatLng={setLatLng}
                      replaceFilter={replaceFilter}
                    />
                  </div>
                )}
              </div>
            );
          })}
          <button
            className="btn-primary no-icon lg-full-width search-btn"
            onClick={() => {
              updateQuery(props.queryInputValue);
            }}
          >
            Search {searchType}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
